import * as React from 'react'

import { SVGResponsive } from './common'

function DaysPerWeek() {
  return (
    <SVGResponsive height={24} width={24}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M2 5c0-1.1046.8954-2 2-2h16c1.1046 0 2 .8954 2 2v15c0 1.1046-.8954 2-2 2H4c-1.1046 0-2-.8954-2-2V5z"
        clipRule="evenodd"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M16 1v4M8 1v4M2 9h20M15 13l-4.125 4L9 15.1818"
      />
    </SVGResponsive>
  )
}

export default React.memo(DaysPerWeek)
